import request from '@js/builders/request_builder/index'

export default {
  getWalletKDF (email, isRecovery = false) {
    return request.kdf()
      .forEmail(email)
      .isRecovery(isRecovery)
      .get()
  }
}



// WEBPACK FOOTER //
// ./src/js/services/common/common.js